import React, { FC } from "react";
import { Box, useTheme } from "@mui/material";

type Props = {
  tableId: number;
  children?: React.ReactNode;
};

const TennisTable: FC<Props> = ({ tableId, children }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ position: "relative", display: "flex", justifyContent: "center" }}
    >
      <Box
        sx={{
          width: 130,
          height: 210,
          borderRadius: 3,
          background: "linear-gradient(to bottom, #1976d2, #0d47a1)",
          border: `2px solid ${theme.palette.grey[100]}`,
          boxShadow: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            bottom: 0,
            left: "50%",
            width: 2,
            backgroundColor: theme.palette.common.white,
            transform: "translateX(-50%)",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            left: 0,
            right: 0,
            height: 2,
            backgroundColor: theme.palette.common.white,
            transform: "translateY(-50%)",
          },
        }}
      >
        {children}
      </Box>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: -12,
          transform: "translateY(-50%)",
          width: 36,
          height: 36,
          bgcolor: "red",
          color: "white",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 16,
          fontWeight: "bold",
          border: `2px solid ${theme.palette.grey[100]}`,
          boxShadow: 2,
        }}
      >
        {tableId}
      </Box>
    </Box>
  );
};

export default TennisTable;
